import Phaser from "phaser";
import { FONT } from "../types";
import { VIEWPORT, preloadUI, addBackground, addMusicBar, addEnterButton, addReturnButton } from "../ui";

const INTRO_TEXTS = [
  "En el mundo de Imperium, criaturas extraordinarias\nconocidas como Guardianes habitan cada rincón.",
  "Como nuevo Maestro, tu misión es formar un equipo\ny demostrar tu valía en combate.",
  "Elegí a tus tres primeros compañeros\ny aventurate a explorar el mundo.",
];

export class IntroScene extends Phaser.Scene {
  private currentIndex = 0;
  private textObj!: Phaser.GameObjects.Text;
  private counterObj!: Phaser.GameObjects.Text;

  constructor() {
    super({ key: "IntroScene" });
  }

  preload(): void {
    preloadUI(this);
  }

  create(): void {
    this.currentIndex = 0;
    addBackground(this);
    addMusicBar(this);

    this.add.text(180, 76, "ImperiumGuardians", {
      fontFamily: FONT, fontSize: "18px", fontStyle: "bold", color: "#f5c242",
    }).setOrigin(0.5);

    // Texto dentro del viewport
    this.textObj = this.add.text(VIEWPORT.x + VIEWPORT.w / 2, VIEWPORT.y + VIEWPORT.h / 2 - 20, INTRO_TEXTS[0], {
      fontFamily: FONT, fontSize: "13px", color: "#fff",
      align: "center", wordWrap: { width: VIEWPORT.w - 20 }, lineSpacing: 6,
    }).setOrigin(0.5);

    this.counterObj = this.add.text(VIEWPORT.x + VIEWPORT.w / 2, VIEWPORT.y + VIEWPORT.h - 18, `1 / ${INTRO_TEXTS.length}`, {
      fontFamily: FONT, fontSize: "11px", color: "#f5c242",
    }).setOrigin(0.5);

    addEnterButton(this, "CONTINUAR", () => this.advance());
    addReturnButton(this, "SALTAR", () => this.scene.start("ChooseCreaturesScene"));
  }

  private advance(): void {
    this.currentIndex++;
    if (this.currentIndex >= INTRO_TEXTS.length) {
      this.scene.start("ChooseCreaturesScene");
      return;
    }
    this.textObj.setText(INTRO_TEXTS[this.currentIndex]);
    this.counterObj.setText(`${this.currentIndex + 1} / ${INTRO_TEXTS.length}`);
  }
}
